module.exports = __webpack_public_path__ + "img/humidity.92dc9a81.gif";